export const formatISOToLocalDate = (
  isoString: string | Date | null | undefined,
  format: "date" | "datetime" | "time" = "datetime"
): string => {
  if (!isoString) return "-";

  try {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    switch (format) {
      case "date":
        return date.toLocaleDateString();
      case "time":
        return date.toLocaleTimeString();
      case "datetime":
      default:
        return date.toLocaleString();
    }
  } catch (error) {
    console.warn("Error formatting date:", error);
    return "Invalid date";
  }
};
